export default __webpack_public_path__ + "static/media/acura.9f8d5660.svg";